import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CollapsePanel } from "../motion/CollapsePanel";
import { IconChevron } from "./icons";
import type { DailyLog } from "../hooks/useDailyLog";

export function DoneTodayStrip({
  log,
  loading,
  isToday,
  homeName,
  totals,
}: {
  log?: DailyLog;
  loading: boolean;
  isToday: boolean;
  homeName: (id: string | null) => string | undefined;
  totals?: { overdue: number; dueToday: number };
}) {
  const [open, setOpen] = useState(false);
  const done = log?.completedTodos ?? [];
  const summary = loading ? "Loading…" : `${done.length} done`;

  return (
    <section className="done-strip" aria-label="Done that day">
      <button type="button" className="done-strip-toggle" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        <span className="done-strip-summary">{summary}</span>
        <motion.span className="done-chev" animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.2 }}>
          <IconChevron />
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {open ? (
          <CollapsePanel className="done-strip-body">
            <div className="done-body">
              <div>
                <p className="agenda-subhead">Done that day ({done.length})</p>
                {done.length === 0 ? (
                  <p className="muted">Nothing completed on this day.</p>
                ) : (
                  <ul className="mini-list">
                    {done.map((t) => (
                      <li key={t.id} className="mini-row">
                        <div className="mini-main">
                          <p className="mini-title">{t.title}</p>
                          {homeName(t.homeId) ? (
                            <div className="mini-meta"><span className="chip">{homeName(t.homeId)}</span></div>
                          ) : null}
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {isToday && totals ? (
                <div className="done-chips">
                  <Link className="chip chip-danger done-chip" to="/todos">Overdue {totals.overdue}</Link>
                  <Link className="chip chip-warn done-chip" to="/todos">Due today {totals.dueToday}</Link>
                </div>
              ) : null}
            </div>
          </CollapsePanel>
        ) : null}
      </AnimatePresence>
    </section>
  );
}
